import { USER_DATA_TYPE } from '@monofront/business/constants';
import logger from '@utils/logger';
import { Banner } from './Banner';
import { ImageBanner } from './ImageBanner';
import { useQueryRules } from 'react-instantsearch-core';

export const Banners = () => {
  const { items } = useQueryRules();

  const banners = items.filter((item) =>
    [USER_DATA_TYPE.COLOR_BANNER, USER_DATA_TYPE.IMAGE_BANNER].includes(
      item.type,
    ),
  );

  const banner = banners[0];

  if (!banner) {
    return null;
  }

  // Navigating between collections briefly leaves the previous collection's
  // rule alongside the new one — often the very same banner twice — so
  // duplicates are a render transient, not necessarily an Algolia rule
  // conflict. Ignore identical ones, warn on distinct ones, and always render
  // the first: this used to throw, which blanked the whole collection page.
  const distinctBanners = new Set(banners.map((item) => JSON.stringify(item)));

  if (distinctBanners.size > 1) {
    logger.warn('More than one banner present, please check Algolia rules', {
      banners,
    });
  }

  switch (banner.type) {
    case USER_DATA_TYPE.COLOR_BANNER:
      return <Banner title={banner.data.title} color={banner.data.color} />;

    case USER_DATA_TYPE.IMAGE_BANNER:
      return <ImageBanner prismicUid={banner.prismic_uid} />;
  }

  return null;
};
